import parse from 'html-react-parser';
import CtaButton from '../ctaButton/ctaButton';
import styles from './checkYourRateCard.module.scss';

export default function CheckYourRateCard({
  brandImage,
  title,
  subTitle,
  ctaLabel,
  endNotes,
  ctaLink,
  ctaNavIcon,
  navIcon,
}) {
  return (
    <div className={styles.cardsWrapper}>
      {brandImage && (
        <img
          className={styles.brandImage}
          data-testid={`${brandImage}-icon`}
          src={brandImage.url}
          alt={brandImage.alt}
          loading="lazy"
        />
      )}
      {navIcon && (
        <img
          data-testid={`${navIcon}-icon`}
          src={navIcon.url}
          alt={navIcon.alt}
          loading="lazy"
        />
      )}
      <div className={styles.titleWrapperNoDescription}>
        <div className={styles.title}>
          <p>{parse(title)}</p>
        </div>
        <div className={styles.subTitle}>
          <p>{parse(subTitle)}</p>
        </div>
      </div>
      <div className={styles.inputWrapper}>
        <CtaButton
          href={ctaLink}
          variant="tertiary"
          className="tally_check_rate_cta"
          label={`${ctaLabel}
          ${
            ctaNavIcon.url && (
              <img src={ctaNavIcon.url} alt={ctaNavIcon.alt} loading="lazy" />
            )
          }`}
        />
      </div>
      <div className={styles.endNotes}>{parse(endNotes)}</div>
    </div>
  );
}
